import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { resolveHome } from './resolveHome';
import { safeReturnTo } from './returnTo';

export default function GuestOnly({ children }) {
  const { session, profile, loading } = useAuth(); const location = useLocation();
  if (loading) return null;
  // The page asked for before sign-in wins; its own guard still checks the role.
  if (session) return <Navigate to={safeReturnTo(location.state?.from) || resolveHome(session, profile)} replace />;
  return children;
}
